import sdl from '@jds/react-generated-sdl/JDSAvatarV2SegmentedRing';
import type { JDSAvatarV2SegmentedRingProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSAvatarV2SegmentedRingProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    disabled = false,
    ariaLabel = 'Avatar with Activity Ring',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, disabled, ariaLabel, ...rest },
    'JDSAvatarV2SegmentedRing',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AvatarV2SegmentedRing = withLogic(
  Component
) as React.FC<JDSAvatarV2SegmentedRingProps> & { slotName?: string };

AvatarV2SegmentedRing.displayName = 'AvatarV2SegmentedRing';
AvatarV2SegmentedRing.slotName = 'jds_avatar_v_2_segmented_ring';

export { AvatarV2SegmentedRing, type JDSAvatarV2SegmentedRingProps };
